import React from 'react';
import PageIntro from '../../components/PageIntro/PageIntro';
import PendingJobsTable from '../../components/Table/PendingJobsTable';

const PendingJobs = () => {
  return (
    <div className='mx-auto max-w-7xl space-y-6'>
      <PageIntro
        title={'Pending Jobs'}
        description={'Review and approve or reject job postings'}
      />
      <PendingJobsTable />
    </div>
  );
};

export default PendingJobs;
